import { render, staticRenderFns } from "./PiFills.vue?vue&type=template&id=8aae6220"
import script from "./PiFills.vue?vue&type=script&lang=js"
export * from "./PiFills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports